/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, FormControl, FormControlLabel, FormLabel, IconButton, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
// import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { SearchCriteria } from '../SearchCriteria';
import { ChartFilter } from '../ChartComponents';
// import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import moment from 'moment';
import { ChartInfo } from '../../components/ChartInfo';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { ChartEmptyState } from '../ChartEmptyState';
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        formControl: {
            display: 'flex',
            flexFlow: 'row wrap',
            alignItems: 'center',
            justifyContent: 'center',
        },
        formLabel: {
            marginRight: '10px',
        },
    }),
);

export enum TaskByCreationEnum {
    LAST_6_MONTHS = 0,
    LAST_12_MONTHS,
    ALL
}

interface TaskByCreationTimesChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
}

interface ChartState {
    options: TaskByCreationEnum;
    taskByCreationByGroup: TaskQueueByCreationTime[];
    formatGrouping: string[];
    taskGrouping: number[];
    effortGrouping: number[];
    grouping: string[];
    totalTasks: number;
}

export const TaskByCreationTimesChart: React.FC<TaskByCreationTimesChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    const [state, setState] = useState<ChartState>({
        options: TaskByCreationEnum.LAST_6_MONTHS,
        taskByCreationByGroup: [],
        formatGrouping: [],
        taskGrouping: [],
        effortGrouping: [],
        grouping: [],
        totalTasks: 0
    });

    // tslint:disable-next-line:no-any
    const taskByCreationQuery = useQuery<TaskByCreationData>(TASK_BY_CREATION_QUERY, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
        },
        fetchPolicy: 'cache-and-network',
    });

    useEffect(() => {
        setState((prevState) => {
            let taskByCreationByGroup: TaskQueueByCreationTime[] = [];
            let formatGrouping: string[] = [];
            let taskGrouping: number[] = [];
            let effortGrouping: number[] = [];
            let grouping: string[] = [];
            let totalTasks: number = 0;
            if (
                taskByCreationQuery.data &&
                taskByCreationQuery.data.statistics &&
                taskByCreationQuery.data.statistics.tasks &&
                taskByCreationQuery.data.statistics.tasks.taskQueueByCreationTimes &&
                !taskByCreationQuery.loading &&
                !taskByCreationQuery.error
            ) {
                const {
                    all,
                    lastSixMonths,
                    lastTwelveMonths
                } = taskByCreationQuery.data.statistics.tasks.taskQueueByCreationTimes;

                if (state.options === TaskByCreationEnum.LAST_6_MONTHS) {
                    taskByCreationByGroup   = lastSixMonths.tasks;
                    formatGrouping          = lastSixMonths.tasks.map((data: TaskQueueByCreationTime) => data.format);
                    taskGrouping            = lastSixMonths.tasks.map((data: TaskQueueByCreationTime) => data.tasks);
                    effortGrouping          = lastSixMonths.tasks.map((data: TaskQueueByCreationTime) => data.effort);
                    grouping                = lastSixMonths.tasks.map((data: TaskQueueByCreationTime) => data.grouping);

                    totalTasks              = lastSixMonths.summary.totalTasks;
                } else if (state.options === TaskByCreationEnum.LAST_12_MONTHS) {
                    taskByCreationByGroup   = lastTwelveMonths.tasks;
                    formatGrouping          = lastTwelveMonths.tasks.map((data: TaskQueueByCreationTime) => data.format);
                    taskGrouping            = lastTwelveMonths.tasks.map((data: TaskQueueByCreationTime) => data.tasks);
                    effortGrouping          = lastTwelveMonths.tasks.map((data: TaskQueueByCreationTime) => data.effort);
                    grouping                = lastTwelveMonths.tasks.map((data: TaskQueueByCreationTime) => data.grouping);

                    totalTasks              = lastTwelveMonths.summary.totalTasks;
                } else {
                    taskByCreationByGroup   = all.tasks;
                    formatGrouping          = all.tasks.map((data: TaskQueueByCreationTime) => data.format);
                    taskGrouping            = all.tasks.map((data: TaskQueueByCreationTime) => data.tasks);
                    effortGrouping          = all.tasks.map((data: TaskQueueByCreationTime) => data.effort);
                    grouping                = all.tasks.map((data: TaskQueueByCreationTime) => data.grouping);

                    totalTasks              = all.summary.totalTasks;
                }
            }

            return {
                ...prevState,
                taskByCreationByGroup,
                formatGrouping,
                taskGrouping,
                effortGrouping,
                grouping,
                totalTasks
            };
        });
        // tslint:disable-next-line: align
    }, [taskByCreationQuery.data, taskByCreationQuery.loading, taskByCreationQuery.error, state.options]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart(`isTaskQueueByAssigneeChartOpen`);
        }
    };

    const onChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        const fieldName = event.target.name;
        setState((prevState) => {
            return {
                ...prevState,
                // tslint:disable-next-line: radix
                [fieldName]: parseInt((event.target as HTMLInputElement).value),
            };
        });
    };

    const onPan = (context: { chart: Chart }) => {
        chartRef.current.options.scales.y.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };

    const handleHeaderDrilldownClick = () => () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();
            var title = 'All Tasks';
            var headerFilter = {
                property: 'CreatedDate',
                operator: 'gt',
                comparison: '',
                period: '',
            };

            if (state.options === TaskByCreationEnum.LAST_6_MONTHS) {
               headerFilter.comparison = moment().add(-6, 'month').format('YYYY-MM-DD');
               title = 'Tasks for the Last 6 Months';
            } else if (state.options === TaskByCreationEnum.LAST_12_MONTHS) {
                headerFilter.comparison = moment().add(-12, 'month').format('YYYY-MM-DD');
                title = 'Tasks for the Last 12 Months';
            } else {
                headerFilter.comparison = '1900-01-01';
            }

            searchCriterias.push(headerFilter);
            props.getSelectedItem(searchCriterias, true, title, DrillDownType.taskSummary, 'Tasks');
        }
    };
    
    if (taskByCreationQuery.loading) {
        return (
            <ChartSkeleton variant="columns" />
        );
    }

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.taskGrouping) ? ' rv-chart--empty' : ''}`}>
            <IconButtonWrapper aria-label="close">
                <ChartInfo 
                    description={props.description}
                    fontSize={props.showAllRecords ? 'large' : 'medium'}
                    className={`${classes.helpIcon} rv-chart-help`}
                />
                <IconButton aria-label="close" onClick={onCloseChart} size="small">
                    <CloseIcon className={classes.closeIcon} />
                </IconButton>
            </IconButtonWrapper>
            <div className={classes.titleContainer}>
                <ChartHeading icon={<AssignmentTurnedInOutlinedIcon />} title="Tasks by Hour Created" />
                <div className={`${classes.total} h2`} onClick={handleHeaderDrilldownClick()}>{state.totalTasks}</div>
                <div className={classes.title}>
                    <span >{`${state.totalTasks > 1 ? 'Tasks' : 'Task'}`}</span>
                </div>
            </div>
            <div className={classes.barContainer}>
                <Bar
                    ref={chartRef}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            const _index = getElementAtEvent(chartRef.current, event)[0].index;

                            const searchCriterias = new Array<SearchCriteria>();

                            if (state.options === TaskByCreationEnum.LAST_6_MONTHS) {
                                searchCriterias.push({ property: 'TaskQueueByCreationTime', operator: '', comparison: state.grouping[_index], period : '6' });
                            } else if (state.options === TaskByCreationEnum.LAST_12_MONTHS) {
                                searchCriterias.push({ property: 'TaskQueueByCreationTime', operator: '', comparison: state.grouping[_index], period : '12' });
                            } else {
                                searchCriterias.push({ property: 'TaskQueueByCreationTime', operator: '', comparison: state.grouping[_index], period : '0' });
                            }

                            const _tempTitle = `Tasks by Hour`;
                            props.getSelectedItem(searchCriterias, true, _tempTitle, DrillDownType.taskSummary, 'Basic Details');
                        }
                    }}
                    data={{
                        labels: getLabels(state.formatGrouping),
                        datasets: [
                            {
                                label: 'Number of Tasks',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                data: state.taskGrouping,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'x' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                suggestedMax: getSuggestedMaxTick(state.taskGrouping),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(state.taskGrouping),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${formatNumber(tickValue)}`;
                                    },
                                },
                            },
                            x: {
                                grid: rvCategoryAxisStyle.grid,
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false,
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: false,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: false,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: false,
                                    },
                                },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            formattedValue,
                                            dataset,
                                        } = context;

                                        var currentValue = convertStringNumberToNumber(formattedValue);

                                        return `${dataset.label}: ${formatNumber(currentValue)}`;
                                    },
                                    // tslint:disable-next-line: no-any no-shadowed-variable
                                    afterLabel: function (context: any) {
                                        const { dataIndex } = context;
                                        const estimatedEffortCount = state.effortGrouping[dataIndex];
                                        return [
                                            `Estimated Effort: ${formatNumber(estimatedEffortCount)}`
                                        ];
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(state.taskGrouping) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            <FormControl component="div" className={classes.formControl}>
                <FormLabel component="legend" className={classes.formLabel}>
                    Show
                </FormLabel>
                <RadioGroup name="options" value={state.options} onChange={onChangeRadio} className={classes.radioGroup}>
                    <FormControlLabel value={TaskByCreationEnum.LAST_6_MONTHS} control={<Radio color="primary" />} label="Last 6 Months" />
                    <FormControlLabel value={TaskByCreationEnum.LAST_12_MONTHS} control={<Radio color="primary" />} label="Last 12 Months" />
                    <FormControlLabel value={TaskByCreationEnum.ALL} control={<Radio color="primary" />} label="All" />
                </RadioGroup>
            </FormControl>
        </div>
    );
};

export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;
export interface TaskByCreationData {
    statistics: Statistics;
}

export interface Statistics {
    tasks: Tasks;
}

export interface Tasks {
    taskQueueByCreationTimes: TaskQueueByCreationTimes;
}

export interface TaskQueueByCreationTimes {
    all:              TaskQueueByCreationTimeGrouping;
    lastSixMonths:    TaskQueueByCreationTimeGrouping;
    lastTwelveMonths: TaskQueueByCreationTimeGrouping;
}

export interface TaskQueueByCreationTimeGrouping {
    tasks: TaskQueueByCreationTime[];
    summary: TaskQueueByCreationTimeSummary;
}

export interface TaskQueueByCreationTimeSummary {
    totalTasks: number;
}

export interface TaskQueueByCreationTime {
    tasks:    number;
    effort:   number;
    grouping: string;
    format:   string;
}

const TASK_BY_CREATION_QUERY = gql`
    fragment FragmentTaskQueueByCreationTimeGrouping on TaskQueueByCreationTimeGrouping {
        tasks {
            tasks,
            effort,
            grouping,
            format
        }
        summary {
            totalTasks
        }
    }

    query TaskQueueByCreationTimes($entityType: Int, $entityGuid: String, $responsibility: Int) {
        statistics {
            tasks {
                taskQueueByCreationTimes(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility){
                    all {
                    ... FragmentTaskQueueByCreationTimeGrouping
                    }
                    lastSixMonths {
                    ... FragmentTaskQueueByCreationTimeGrouping
                    }
                    lastTwelveMonths {
                    ... FragmentTaskQueueByCreationTimeGrouping
                    }
                }
            }
        }
    }
`;
